import React from 'react';
import CustomPageNestedLinks from 'components/appbar/mobile/CustomPageNestedLinks';
import CustomPageLink from 'components/appbar/CustomPageLink';
import DrawerListItem from 'components/appbar/mobile/DrawerListItem';
import styled from 'styled-components';
import { CustomPageGroup } from 'models/types/customPage';

const DrawerVerticalLinks = styled.div`
  display: inherit;
`;

export interface DrawerCustomPagesProps {
  customPages?: CustomPageGroup[];
}

const DrawerCustomPages = ({ customPages = [] }: DrawerCustomPagesProps) => (
  <>
    {(customPages as CustomPageGroup[]).map((pageData, groupIndex) => {
      const {
        pages, display,
      } = pageData;
      switch (display) {
        case 'TOPBAR':
          return (
            <DrawerVerticalLinks key={groupIndex} id={`custom-page-group-${groupIndex}`}>
              {pages.map((page, itemIndex) => (
                <DrawerListItem button key={itemIndex}>
                  <CustomPageLink {...page} />
                </DrawerListItem>
              ))}
            </DrawerVerticalLinks>
          );
        case 'DROPDOWN':
          return (
            <CustomPageNestedLinks
              key={groupIndex}
              {...pageData}
            />
          );
        default:
          return null;
      }
    })}
  </>
);

export default DrawerCustomPages;
